<template>
  <label class="edition">
    <input type="radio" name="edition" class="hidden" :checked="checked" @click="$emit('click')" />
    <div class="edition-label">
      <div class="flex-1">
        <p class="uppercase font-semibold tracking-wide">{{ packageEdition.name }}</p>
        <p class="secondary">από {{ price }} euro</p>
      </div>
      <div v-if="checked" class="flex-none self-center">
        <FontAwesomeIcon icon="check" size="lg" class="text-white" />
      </div>
    </div>
  </label>
</template>

<script>
import { entityComputed } from '@/store/helper';

export default {
  name: 'PackageEditionRadioButtonVue',
  props: {
    packageEdition: {
      type: Object,
      required: true,
    },
    checked: Boolean,
    basePrice: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...entityComputed,
    price() {
      return this.packageEdition.packageItems.reduce((acc, cur) => {
        const { price = 0 } = this.entityById('packageItems', cur) || {};
        return acc + price;
      }, +this.basePrice);
    },
  },
};
</script>

<style lang="postcss" scoped>
.edition-label {
  @apply flex pl-6 pr-4 py-4 border border-gray-400 rounded;
}
.edition-label:hover {
  @apply border-indigo-600;
}
.edition-label .secondary {
  @apply text-gray-600 text-sm;
}
.edition > input:checked + .edition-label {
  @apply border-indigo-600 bg-indigo-500 text-white shadow-lg;
}
.edition > input:checked + .edition-label .secondary {
  @apply text-indigo-200;
}
</style>
